export class SectorPolygon {
    public id: string;
    public technicalSectorId: string;
    public name: string;
    public layer: string;
    public validFrom: Date;
    public validTo: Date;
    public wkt: string;

    constructor()
    constructor(json: any)
    constructor(json?: SectorPolygon) {
        Object.assign(this, json);
        this.validFrom = new Date(json.validFrom);
        this.validTo = new Date(json.validTo);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/sector/sector-polygon.ts